import { BMP_Buffer } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPBuffer = (user_id?: number): Promise<BMP_Buffer[]> => {
    return new Promise<BMP_Buffer[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/buffer/${user_id}`).then((response) => {
            resolve(response.data as BMP_Buffer[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};